/** Canonical Cloudflare RealtimeKit platform value from the migrated backend. */
export const VIDEO_PLATFORM_REALTIMEKIT = "realtimekit";

/**
 * Legacy Mongo / pre-migration platform value.
 * Kept for historical meetings that still store videoPlatform: "dyte".
 */
export const VIDEO_PLATFORM_DYTE_LEGACY = "dyte";

/**
 * True when the meeting should open the HIDOC in-app video flow
 * (RealtimeKit), including legacy Mongo records still marked "dyte".
 * Zoom and other platforms remain false.
 */
export const isHidocVideoMeeting = (meetingOrPlatform) => {
  const platform =
    typeof meetingOrPlatform === "string"
      ? meetingOrPlatform
      : meetingOrPlatform?.videoPlatform;
  return (
    platform === VIDEO_PLATFORM_REALTIMEKIT ||
    platform === VIDEO_PLATFORM_DYTE_LEGACY
  );
};

/**
 * Canonical meeting provider payload with required legacy Mongo fallback.
 */
export const getVideoMeetingResponse = (meeting) =>
  meeting?.realtimeKitMeetingResponse || meeting?.dyteMeetingResponse || null;
